/**
 * Принимает список функций в виде аргументов и возвращает функцию,
 * которая принимает некоторое значение в качестве аргумента.
 * Ранее переданные функцию будут работать с этим value
 */
export const pipe =
    <T>(...fns: Array<(arg: T) => T>) =>
    (value: T) =>
        fns.reduce((acc, fn) => fn(acc), value);
